import { AlertTriangle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface MaintenanceWarningModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  message: string;
  estimatedEnd: string | null;
  autoSaveEnabled: boolean;
}

export const MaintenanceWarningModal: React.FC<MaintenanceWarningModalProps> = ({
  open,
  onOpenChange,
  message,
  estimatedEnd,
  autoSaveEnabled,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-maintenance-warn" />
            <DialogTitle>Manutenção Programada</DialogTitle>
          </div>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>

        <div className="space-y-3 text-sm">
          {estimatedEnd && (
            <p>
              <span className="font-medium">Previsão de retorno:</span>{" "}
              {new Date(estimatedEnd).toLocaleString("pt-BR")}
            </p>
          )}
          {autoSaveEnabled && (
            <p className="text-muted-foreground">
              Seu trabalho será salvo automaticamente antes da manutenção.
            </p>
          )}
        </div>

        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>Entendi</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
